import { Alert } from '@luminalearning/components';

type Props = {
    /** String containing the error message */
    errorMessage: string;
};

const ErrorContainer = (props: Props) => {
    const {
        errorMessage,
    } = props;

    return (
        <>
            <Alert type={'Error'} message={errorMessage} />
        </>
    );
};

export default ErrorContainer;